import { combineReducers } from "redux";

import {
  ISearchReply,
  ISearchRequest,
} from "../api";
import { RootAction } from "../types";

function query(state: ISearchRequest | null = null, action: RootAction): ISearchRequest | null {
  switch (action.type) {
    case 'UPDATE_QUERY':
      return action.payload;
    case 'MORE_RESULTS_SUCCESS':
      return action.payload.query;
    default:
      return state;
  }
}

function results(state: ISearchReply[] = [], action: RootAction): ISearchReply[] {
  switch (action.type) {
    case 'DO_SEARCH_SUCCESS':
      return [...state, action.payload];
    case 'DO_SEARCH_REQUEST':
    case 'DO_SEARCH_FAILURE':
      return [];
    case 'MORE_RESULTS_SUCCESS':
      return [...state, action.payload.results];
    default:
      return state;
  }
}

function isLoading(state: boolean = false, action: RootAction): boolean {
  switch (action.type) {
    case 'DO_SEARCH_FAILURE':
    case 'DO_SEARCH_SUCCESS':
    case 'MORE_RESULTS_FAILURE':
    case 'MORE_RESULTS_SUCCESS':
      return false;
    case 'MORE_RESULTS_REQUEST':
    case 'DO_SEARCH_REQUEST':
      return true;
    default:
      return state;
  }
}

function resultsTotal(state: number | null = null, action: RootAction): number | null {
  switch (action.type) {
    case 'DO_SEARCH_SUCCESS':
      return action.payload.total_hits;
    case 'DO_SEARCH_REQUEST':
      return null;
    default:
      return state;
  }
}

function error(state: Error | null = null, action: RootAction): Error | null {
  switch (action.type) {
    case 'DO_SEARCH_FAILURE':
      return action.payload;
    case 'DO_SEARCH_REQUEST':
      return null;
    case 'MORE_RESULTS_FAILURE':
      return action.payload;
    default:
      return state;
  }
}

export const searchReducer = combineReducers({
  error,
  isLoading,
  query,
  results,
  resultsTotal,
});
export default searchReducer;



// WEBPACK FOOTER //
// ./src/reducers/searchReducer.ts